export default __webpack_public_path__ + "static/myles-borins-c89fa0125d8d7dd6ea9fba901072f72e.jpg";